import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lightbulb, Flag } from "lucide-react";
import { HostSuggestionModal } from "@/components/suggestions/HostSuggestionModal";
import ReportDialog from "@/components/ReportDialog";

interface PlaceFeedbackCardProps {
  placeId: string;
  placeName: string;
  placeSlug: string;
}

export function PlaceFeedbackCard({ placeId, placeName, placeSlug }: PlaceFeedbackCardProps) {
  const [hostTipOpen, setHostTipOpen] = useState(false);

  return (
    <>
      <Card className="bg-muted/20 border-border/30">
        <CardContent className="p-4 md:p-5 space-y-3">
          <div>
            <h3 className="font-display text-base mb-0.5 text-foreground">
              Hjälp oss hålla Farmly levande
            </h3>
            <p className="text-sm text-muted-foreground">
              Saknar du något här eller har vi missat något?
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setHostTipOpen(true)}
            >
              <Lightbulb className="h-4 w-4 mr-1.5" />
              Tipsa om en värd
            </Button>
            <ReportDialog placeId={placeId} placeName={placeName} placeSlug={placeSlug} />
          </div>
        </CardContent>
      </Card>

      <HostSuggestionModal
        open={hostTipOpen}
        onOpenChange={setHostTipOpen}
        sourcePlaceId={placeId}
        sourcePlaceName={placeName}
      />
    </>
  );
}
